"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[164],{

/***/ 2620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5992);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8675);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1075);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7550);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2197);
/* harmony import */ var _LinkTo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8450);
/* harmony import */ var components_IconButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2594);
/* harmony import */ var _mui_icons_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2965);
/* harmony import */ var _mui_icons_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3321);
/* harmony import */ var _SongStarterLogo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8286);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9179);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}








var FooterContainer = (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme;
    return _defineProperty({
        borderTop: "4px solid #444",
        paddingTop: "56px",
        backgroundColor: "rgba(22,22,22,1)"
    }, theme.breakpoints.down("sm"), {
        paddingLeft: "24px",
        paddingRight: "24px"
    });
});
var IconButtonSocial = (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(components_IconButton__WEBPACK_IMPORTED_MODULE_3__/* .IconButton */ .h)(function() {
    return {
        borderRadius: 26,
        backgroundColor: "rgba(53,53,53,1)"
    };
});
var Footer = function() {
    var ref = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)("header"), theader = ref.t;
    var ref1 = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)("common"), tcommon = ref1.t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterContainer, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            maxWidth: "xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                    container: true,
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                            item: true,
                            xs: 12,
                            md: 3,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                mt: "-10px",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SongStarterLogo__WEBPACK_IMPORTED_MODULE_4__/* .SongStarterLogo */ .n, {})
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                            item: true,
                            xs: 6,
                            md: 2,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    variant: "body1",
                                    sx: {
                                        fontWeight: 700
                                    },
                                    color: "textSecondary",
                                    children: tcommon("named_home_title")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                [
                                    {
                                        label: theader("home"),
                                        route: "/"
                                    }
                                ].map(function(item) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LinkTo__WEBPACK_IMPORTED_MODULE_2__/* .LinkTo */ .e, {
                                        sx: {
                                            marginBottom: 2,
                                            display: "block"
                                        },
                                        color: "textPrimary",
                                        variant: "body2",
                                        href: item.route,
                                        children: item.label
                                    }, item.route);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                            item: true,
                            xs: 6,
                            md: 3,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    variant: "body1",
                                    sx: {
                                        fontWeight: 700
                                    },
                                    color: "textSecondary",
                                    children: theader("support")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                [
                                    {
                                        label: theader("contact"),
                                        route: "/contact"
                                    }
                                ].map(function(item) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LinkTo__WEBPACK_IMPORTED_MODULE_2__/* .LinkTo */ .e, {
                                        sx: {
                                            marginBottom: 2,
                                            display: "block"
                                        },
                                        color: "textPrimary",
                                        variant: "body2",
                                        href: item.route,
                                        children: item.label
                                    }, item.route);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                            item: true,
                            container: true,
                            justifyContent: "flex-end",
                            xs: 12,
                            md: 3,
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                                    item: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconButtonSocial, {
                                        label: "Instagram",
                                        size: "large",
                                        onClick: function(e) {
                                            e.stopPropagation();
                                            window.open("https://www.instagram.com/songstarter.official", "_blank");
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                            fontSize: "inherit"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                                    item: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconButtonSocial, {
                                        label: "Facebook",
                                        size: "large",
                                        onClick: function(e) {
                                            e.stopPropagation();
                                            window.open("https://www.facebook.com/songstarter.official", "_blank");
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                            fontSize: "inherit"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    sx: {
                        padding: "32px 0px"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                        container: true,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                                item: true,
                                xs: 12,
                                md: 6,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LinkTo__WEBPACK_IMPORTED_MODULE_2__/* .LinkTo */ .e, {
                                        variant: "caption",
                                        href: "/terms-of-use",
                                        color: "textSecondary",
                                        underline: "hover",
                                        children: tcommon("terms_of_use")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LinkTo__WEBPACK_IMPORTED_MODULE_2__/* .LinkTo */ .e, {
                                        color: "textSecondary",
                                        variant: "caption",
                                        href: "/privacy-policy",
                                        underline: "hover",
                                        sx: {
                                            marginLeft: "16px"
                                        },
                                        children: tcommon("privacy_policy")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                                item: true,
                                xs: 12,
                                md: 6,
                                style: {
                                    textAlign: "right"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    variant: "caption",
                                    color: "textSecondary",
                                    children: tcommon("footer_copyrights", {
                                        year: new Date().getFullYear()
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 2594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ IconButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8364);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5801);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



function IconButton(_param) {
    var label = _param.label, disabled = _param.disabled, style = _param.style, id = _param.id, props = _objectWithoutProperties(_param, [
        "label",
        "disabled",
        "style",
        "id"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        title: label,
        disableFocusListener: disabled,
        disableHoverListener: disabled,
        disableTouchListener: disabled,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            id: id || label,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread({
                style: style,
                disabled: disabled
            }, props))
        })
    }, disabled ? 1 : 2);
}


/***/ }),

/***/ 8450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ LinkTo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5992);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2078);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var DisabledDiv = (0,_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)("div")(function() {
    return {
        width: "100%",
        height: "100%"
    };
});
var LinkTo = function(_param) {
    var href = _param.href, children = _param.children, _underline = _param.underline, underline = _underline === void 0 ? "none" : _underline, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, props = _objectWithoutProperties(_param, [
        "href",
        "children",
        "underline",
        "disabled"
    ]);
    if (disabled) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DisabledDiv, {
        children: children
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpread({
            underline: underline,
            href: href
        }, props, {
            children: children
        }))
    });
};



/***/ }),

/***/ 2847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L$": function() { return /* binding */ SongStarterHeader; }
});

// UNUSED EXPORTS: HEADER_HEIGHT_SCROLLED, dummyUserData

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/@mui/material/AppBar/AppBar.js + 1 modules
var AppBar = __webpack_require__(6897);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(1075);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Container/Container.js + 2 modules
var Container = __webpack_require__(8675);
// EXTERNAL MODULE: ./components/LinkTo.tsx
var LinkTo = __webpack_require__(8450);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(5992);
;// CONCATENATED MODULE: ./components/backgroundCSS.tsx
var backgroundCSS = {
    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
    "@supports (backdrop-filter: blur(20px))": {
        backgroundColor: "rgba(0,0,0,0.2)"
    },
    "@supports not (backdrop-filter: blur(20px))": {
        backgroundColor: "rgba(0,0,0,0.8)"
    }
};

// EXTERNAL MODULE: ./components/SongStarterLogo.tsx + 1 modules
var SongStarterLogo = __webpack_require__(8286);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./hooks/useEffectOnce.tsx

var useEffectOnce = function(effect) {
    (0,react.useEffect)(effect, []);
};
/* harmony default export */ var hooks_useEffectOnce = (useEffectOnce);

;// CONCATENATED MODULE: ./hooks/useUnmount.tsx


var useUnmount = function(fn) {
    var fnRef = (0,react.useRef)(fn);
    // update the ref each render so if it change the newest callback will be invoked
    fnRef.current = fn;
    hooks_useEffectOnce(function() {
        return function() {
            return fnRef.current();
        };
    });
};

;// CONCATENATED MODULE: ./hooks/useRafState.tsx


var useRafState = function(initialState) {
    var frame = (0,react.useRef)(0);
    var ref = (0,react.useState)(initialState), state = ref[0], setState = ref[1];
    var setRafState = (0,react.useCallback)(function(value) {
        cancelAnimationFrame(frame.current);
        frame.current = requestAnimationFrame(function() {
            setState(value);
        });
    }, []);
    useUnmount(function() {
        cancelAnimationFrame(frame.current);
    });
    return [
        state,
        setRafState
    ];
};

;// CONCATENATED MODULE: ./hooks/useWindowScroll.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


function on(obj) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    if (obj && obj.addEventListener) {
        var _obj;
        (_obj = obj).addEventListener.apply(_obj, _toConsumableArray(args));
    }
}
function off(obj) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    if (obj && obj.removeEventListener) {
        var _obj;
        (_obj = obj).removeEventListener.apply(_obj, _toConsumableArray(args));
    }
}
var isBrowser = "object" !== "undefined";
var useWindowScroll = function() {
    var ref = _slicedToArray(useRafState(function() {
        return {
            x: isBrowser ? window.pageXOffset : 0,
            y: isBrowser ? window.pageYOffset : 0
        };
    }), 2), state1 = ref[0], setState = ref[1];
    (0,react.useEffect)(function() {
        var handler = function() {
            setState(function(state) {
                var pageXOffset = window.pageXOffset, pageYOffset = window.pageYOffset;
                //Check state for change, return same state if no change happened to prevent rerender
                //(see useState/setState documentation). useState/setState is used internally in useRafState/setState.
                return state.x !== pageXOffset || state.y !== pageYOffset ? {
                    x: pageXOffset,
                    y: pageYOffset
                } : state;
            });
        };
        //We have to update window scroll at mount, before subscription.
        //Window scroll may be changed between render and effect handler.
        handler();
        on(window, "scroll", handler, {
            capture: false,
            passive: true
        });
        return function() {
            off(window, "scroll", handler);
        };
    }, []);
    return state1;
};

;// CONCATENATED MODULE: ./components/SongStarterHeader.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var HEADER_HEIGHT_SCROLLED = 64;
var HEADER_HEIGHT = 85;
var Header = (0,styled/* default */.ZP)(AppBar/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "headerScrolled" && prop !== "menuOpen";
    }
})(function(param) {
    var theme = param.theme, headerScrolled = param.headerScrolled, menuOpen = param.menuOpen;
    return _objectSpread({
        height: headerScrolled ? HEADER_HEIGHT_SCROLLED : HEADER_HEIGHT,
        top: "0px",
        position: "fixed",
        width: "100%",
        zIndex: theme.zIndex.appBar + 10,
        transition: "height 0.4s cubic-bezier(0, 0, 0, 1) 0s",
        overflow: "hidden",
        boxShadow: "unset"
    }, headerScrolled || menuOpen ? _objectSpread({}, backgroundCSS) : {
        background: "unset"
    }, menuOpen && {
        height: "100%"
    });
});
var GridLogo = (0,styled/* default */.ZP)(Grid/* default */.ZP)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        cursor: "pointer",
        width: 360,
        minWidth: 360
    }, _defineProperty(_obj, theme.breakpoints.down("lg"), {
        width: 160,
        minWidth: 160
    }), _defineProperty(_obj, "> a", {
        color: "#fff"
    }), _obj;
});
var dummyUserData = {
    firstNamePers: "A",
    lastNamePers: "B",
    id: "ABC"
};
var SongStarterHeader = function(param) {
    var scrolled = param.scrolled, _scrollFrom = param.scrollFrom, scrollFrom = _scrollFrom === void 0 ? 50 : _scrollFrom;
    var y = useWindowScroll().y;
    var headerScrolled = scrolled || y > scrollFrom;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
        headerScrolled: headerScrolled,
        menuOpen: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "xl",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                flexWrap: "nowrap",
                sx: {
                    height: headerScrolled ? HEADER_HEIGHT_SCROLLED : HEADER_HEIGHT,
                    transition: "height 0.4s cubic-bezier(0, 0, 0, 1) 0s"
                },
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GridLogo, {
                    item: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTo/* LinkTo */.e, {
                        href: "/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SongStarterLogo/* SongStarterLogo */.n, {})
                    })
                })
            })
        })
    });
};


/***/ }),

/***/ 8286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ SongStarterLogo; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(7550);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(2197);
;// CONCATENATED MODULE: ./icons/SongStarterIcon.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var SongStarterIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", _objectSpread({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "640",
        height: "640",
        viewBox: "0 0 640 640"
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            transform: "matrix(1.3333333,0,0,-1.3333333,0,640)",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                transform: "scale(0.1)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "m 533.789,2387.02 c -11.391,455.85 163.18,894.86 459.199,1236.43 170.822,261.6 832.252,176.31 1080.102,57.9 183.74,-71.63 371.31,-189.89 502.58,-339.13 -28.47,-2.08 -56.94,-4.15 -85.42,-6.23 -35.5,1.77 -71.01,3.55 -106.52,5.33 -97.74,-2.93 -196.2,-12.61 -286.45,-47.47 -458.53,-135.87 -741.46,-669.63 -610.27,-1124.17 101.37,-518.97 708.63,-842.93 1198.95,-666.65 111.92,27.05 178.2,96.8 72.79,-61.19 C 2621.48,1249.01 2446.33,1078.37 2237.63,969.27 2008.99,845.621 1734.11,759.18 1473.62,783.711 904.336,1097.99 528.535,1740.18 533.789,2387.02"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "m 4245.9,2687.7 c 176.4,-1115.5 -717,-2155.802 -1840,-2157.302 -355.5,18.903 -295.7,10.903 -19.2,136.102 224.8,131 442,299.699 595.3,517.2 312.6,415.2 445.7,983.6 325.9,1492.3 -142.9,680.7 -705.2,1267.4 -1396,1398.3 -36,5.7 -72.7,12 -110.1,18.8 -35.7,6.6 -70.7,13.4 -105,20.5 33.6,43.9 94.7,45.8 143,68.2 113.5,34.6 229.3,52.9 345.8,74.2 966.8,130.6 1917.1,-610.2 2060.3,-1568.3"
                    })
                ]
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/SongStarterLogo.tsx




var SongStarterLogo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            display: "flex",
            width: "100%",
            height: "40px",
            alignItems: "center",
            svg: {
                width: "36px",
                height: "36px",
                marginRight: "12px",
                color: "inherit",
                fill: "currentColor"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SongStarterIcon, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "subtitle2",
                sx: {
                    color: "inherit",
                    letterSpacing: -0.1
                },
                children: "SongStarter"
            })
        ]
    });
};


/***/ })

}]);